/* Інциденти й ескалація (/incidents, docs/processes C2). Kept apart from uk.ts/en.ts to keep merges small. */
export const incidentsUk = {
  'nav.incidents': 'Інциденти',
  'incidents.title': 'Інциденти',
  'incidents.subtitle': 'Поломки, скарги, надзвичайні події та «Код червоний» — з таймерами реакції й ескалацією',
  'incidents.new': 'Інцидент',
  'incidents.code': 'Код червоний',
  'incidents.csv': 'CSV',
  'incidents.reportTitle': 'Новий інцидент',
  'incidents.reportHint': 'Оберіть тип, коротко опишіть, що сталося, додайте фото — відповідальні отримають сповіщення одразу.',
  'incidents.type': 'Тип',
  'incidents.body': 'Що сталося',
  'incidents.bodyPlaceholder': 'Коротко: що, де, чи є постраждалі',
  'incidents.branch': 'Філія',
  'incidents.anyBranch': 'Не вказано',
  'incidents.room': 'Кабінет / зона',
  'incidents.roomHint': 'Напр. «Кабінет 2», «ВРІТ», «Рецепція»',
  'incidents.photos': 'Фото',
  'incidents.photosHint': 'До 5 фото, до 10 МБ кожне',
  'incidents.photosChosen': 'Обрано фото: {n}',
  'incidents.channel': 'Канал звернення',
  'incidents.send': 'Надіслати',
  'incidents.sent': 'Інцидент №{n} зареєстровано',
  'incidents.uploadFailed': 'Не вдалося завантажити фото',
  'incidents.guidance': 'Що робити',
  'incidents.slaHint': 'Реакція: {ack} · вирішити: {resolve}',
  'incidents.toConfirm': 'Потребує підтвердження',
  'incidents.noTypes': 'Типів інцидентів ще немає',
  'incidents.codeTitle': 'Оголосити код',
  'incidents.codeHint': 'Колеги на зміні (якщо зміну ніхто не позначив — усі лікарі, асистенти й адміністратори) одразу отримають термінове сповіщення в Telegram і застосунку.',
  'incidents.codeRed': 'Код червоний',
  'incidents.codeRedHint': 'Тяжкий пацієнт — потрібні всі вільні руки',
  'incidents.codeYellow': 'Код жовтий',
  'incidents.codeYellowHint': 'Терміново потрібен вільний лікар',
  'incidents.codeNote': 'Коментар',
  'incidents.codeRaise': 'Оголосити',
  'incidents.codeRaised': 'Код оголошено, сповіщено колег: {n}',
  'incidents.activeCodes': 'Активні коди',
  'incidents.coming': 'Іду',
  'incidents.busy': 'Зайнятий',
  'incidents.comingCount': 'Ідуть: {n}',
  'incidents.duty.on': 'На зміні до {time}',
  'incidents.duty.off': 'Я на зміні',
  'incidents.duty.title': 'Моя зміна',
  'incidents.duty.hint': '«Код червоний» надходить першими тим, хто позначив зміну у своїй філії.',
  'incidents.duty.hours': 'Тривалість, год',
  'incidents.duty.start': 'Почати зміну',
  'incidents.duty.end': 'Завершити зміну',
  'incidents.duty.now': 'Зараз на зміні',
  'incidents.duty.nobody': 'Зміну поки ніхто не позначив.',
  'incidents.tab.register': 'Реєстр',
  'incidents.tab.stats': 'Статистика',
  'incidents.tab.types': 'Типи і SLA',
  'incidents.filter.status': 'Статус',
  'incidents.filter.open': 'Відкриті',
  'incidents.filter.all': 'Усі статуси',
  'incidents.filter.closed': 'Вирішені й закриті',
  'incidents.filter.category': 'Категорія',
  'incidents.filter.allCategories': 'Усі категорії',
  'incidents.filter.type': 'Тип',
  'incidents.filter.allTypes': 'Усі типи',
  'incidents.filter.allBranches': 'Усі філії',
  'incidents.filter.overdue': 'Лише прострочені',
  'incidents.filter.mine': 'Мої',
  'incidents.search': 'Текст, кабінет або №',
  'incidents.col.number': '№',
  'incidents.col.type': 'Тип',
  'incidents.col.title': 'Що сталося',
  'incidents.col.status': 'Статус',
  'incidents.col.sla': 'Таймер',
  'incidents.col.reported': 'Повідомлено',
  'incidents.col.owner': 'Відповідальний',
  'incidents.empty': 'Відкритих інцидентів немає',
  'incidents.emptyHint': 'Помітили поломку, скаргу чи небезпеку? Натисніть «Інцидент» — відповідальні отримають сповіщення. У Telegram-боті — кнопка «📝 Інцидент».',
  'incidents.sla.ack': 'реакція',
  'incidents.sla.resolve': 'вирішення',
  'incidents.sla.left': '{what} за {left}',
  'incidents.sla.late': '{what}: прострочено на {left}',
  'incidents.overdue': 'Прострочено',
  'incidents.legal': 'Юридична ескалація',
  'incidents.managersOnly': 'Лише керівникам',
  'incidents.status.new': 'Новий',
  'incidents.status.acknowledged': 'Взято',
  'incidents.status.in_progress': 'В роботі',
  'incidents.status.resolved': 'Вирішено',
  'incidents.status.closed': 'Закрито',
  'incidents.status.cancelled': 'Скасовано',
  'incidents.category.emergency': 'Невідкладне',
  'incidents.category.complaint': 'Скарги й конфлікти',
  'incidents.category.technical': 'Технічне',
  'incidents.category.clinical': 'Клінічне',
  'incidents.category.safety': 'Охорона праці',
  'incidents.category.insurance': 'Страхові події',
  'incidents.category.memo': 'Пам’ятки',
  'incidents.category.other': 'Інше',
  'incidents.channel.phone': 'Телефон',
  'incidents.channel.instagram': 'Instagram',
  'incidents.channel.email': 'Email',
  'incidents.channel.in_person': 'Особисто',
  'incidents.channel.review': 'Відгук',
  'incidents.channel.telegram': 'Telegram',
  'incidents.channel.viber': 'Viber',
  'incidents.channel.other': 'Інше',
  'incidents.severity.low': 'Низька',
  'incidents.severity.normal': 'Звичайна',
  'incidents.severity.high': 'Висока',
  'incidents.severity.critical': 'Критична',
  'incidents.dur.min': '{n} хв',
  'incidents.dur.hours': '{n} год',
  'incidents.dur.days': '{n} дн',
  'incidents.detail': 'Інцидент',
  'incidents.number': '№{n}',
  'incidents.take': 'Беру',
  'incidents.toWork': 'В роботу',
  'incidents.resolve': 'Вирішено',
  'incidents.close': 'Закрити',
  'incidents.cancel': 'Скасувати інцидент',
  'incidents.reopen': 'Повернути в роботу',
  'incidents.resolveTitle': 'Як вирішено?',
  'incidents.closeTitle': 'Закрити інцидент',
  'incidents.cancelTitle': 'Скасувати інцидент',
  'incidents.reopenTitle': 'Повернути в роботу',
  'incidents.resolution': 'Рішення',
  'incidents.resolutionHint': 'Що зроблено; для скарг — відповідь клієнту',
  'incidents.reason': 'Причина',
  'incidents.comment': 'Коментар',
  'incidents.confirm': 'Підтвердити',
  'incidents.field.ackDue': 'Реакція до',
  'incidents.field.resolveDue': 'Вирішити до',
  'incidents.field.acknowledged': 'Взято',
  'incidents.field.resolved': 'Вирішено',
  'incidents.field.owner': 'Відповідальний',
  'incidents.field.reporter': 'Повідомив(ла)',
  'incidents.field.place': 'Де',
  'incidents.field.channel': 'Канал',
  'incidents.field.decision': 'Рішення щодо скарги',
  'incidents.field.asset': 'Обладнання',
  'incidents.field.source': 'Джерело',
  'incidents.source.web': 'Сайт',
  'incidents.source.telegram': 'Telegram-бот',
  'incidents.source.api': 'API / MCP',
  'incidents.byWhom': '{when} · {who}',
  'incidents.saveDecision': 'Зберегти рішення',
  'incidents.assign': 'Призначити',
  'incidents.assignRole': 'Роль',
  'incidents.assignUser': 'Співробітник',
  'incidents.anyone': 'Будь-хто з ролі',
  'incidents.noRole': 'Керівники',
  'incidents.deadlines': 'Строки за регламентом',
  'incidents.deadlineMet': 'Виконано',
  'incidents.checklist': 'Чекліст',
  'incidents.openChecklist': 'Відкрити чекліст',
  'incidents.checklistProgress': 'Виконано {answered} з {total}',
  'incidents.responses': 'Відповіді на код',
  'incidents.noResponses': 'Ще ніхто не відповів',
  'incidents.photosTitle': 'Фото ({n})',
  'incidents.timeline': 'Хронологія',
  'incidents.commentPlaceholder': 'Що зроблено, що ще потрібно…',
  'incidents.attach': 'Додати фото',
  'incidents.sendComment': 'Надіслати',
  'incidents.event.created': 'Повідомлено',
  'incidents.event.comment': 'Коментар',
  'incidents.event.status': 'Статус: {from} → {to}',
  'incidents.event.assign': 'Змінено відповідального',
  'incidents.event.update': 'Змінено дані',
  'incidents.event.escalation.ack': 'Ескалація: немає реакції вчасно',
  'incidents.event.escalation.resolve': 'Ескалація: не вирішено вчасно',
  'incidents.event.alert': 'Сповіщено колег: {n}',
  'incidents.event.response.coming': 'Іде',
  'incidents.event.response.busy': 'Зайнятий',
  'incidents.event.photo': 'Додано фото',
  'incidents.event.deadline': 'Пропущено строк: {label}',
  'incidents.system': 'Система',
  'incidents.stats.total': 'Інцидентів',
  'incidents.stats.open': 'Відкриті',
  'incidents.stats.overdue': 'Прострочені',
  'incidents.stats.ackRate': 'Реакція вчасно',
  'incidents.stats.resolveRate': 'Вирішено вчасно',
  'incidents.stats.avgAck': 'Середня реакція',
  'incidents.stats.avgResolve': 'Середнє вирішення',
  'incidents.stats.count': 'Кількість',
  'incidents.stats.byMonth': 'По місяцях',
  'incidents.stats.month': 'Місяць',
  'incidents.stats.empty': 'За цей період інцидентів не було',
  'incidents.stats.period': 'Період',
  'incidents.stats.days': 'Останні {n} днів',
  'incidents.types.owner': 'Відповідає',
  'incidents.types.escalate': 'Ескалація',
  'incidents.types.ack': 'Реакція',
  'incidents.types.resolve': 'Вирішення',
  'incidents.types.deadlines': 'Строки',
  'incidents.types.edit': 'Змінити «{title}»',
  'incidents.types.editTitle': 'Тип інциденту',
  'incidents.types.ackMin': 'Реакція, хв',
  'incidents.types.resolveMin': 'Вирішення, хв',
  'incidents.types.active': 'Активний',
  'incidents.types.confirmed': 'Значення підтверджено власником',
  'incidents.types.seed': 'Додати стандартні типи',
  'incidents.types.saved': 'Збережено',
  'incidents.types.inactive': 'Архів',
  'today.openIncidents': 'Відкриті інциденти',
  'today.noIncidents': 'Відкритих інцидентів немає',
}

export const incidentsEn: { [K in keyof typeof incidentsUk]?: string } = {
  'nav.incidents': 'Incidents',
  'incidents.title': 'Incidents',
  'incidents.subtitle': 'Breakdowns, complaints, emergencies and «Code red» — with response timers and escalation',
  'incidents.new': 'Incident',
  'incidents.code': 'Code red',
  'incidents.csv': 'CSV',
  'incidents.reportTitle': 'New incident',
  'incidents.reportHint': 'Pick a type, describe briefly what happened, add photos — the owners are notified at once.',
  'incidents.type': 'Type',
  'incidents.body': 'What happened',
  'incidents.bodyPlaceholder': 'Briefly: what, where, anyone hurt',
  'incidents.branch': 'Branch',
  'incidents.anyBranch': 'Not set',
  'incidents.room': 'Room / zone',
  'incidents.roomHint': 'E.g. “Room 2”, “ICU”, “Reception”',
  'incidents.photos': 'Photos',
  'incidents.photosHint': 'Up to 5 photos, 10 MB each',
  'incidents.photosChosen': 'Photos chosen: {n}',
  'incidents.channel': 'Channel',
  'incidents.send': 'Send',
  'incidents.sent': 'Incident #{n} reported',
  'incidents.uploadFailed': 'Could not upload the photo',
  'incidents.guidance': 'What to do',
  'incidents.slaHint': 'Response: {ack} · resolve: {resolve}',
  'incidents.toConfirm': 'To confirm',
  'incidents.noTypes': 'No incident types yet',
  'incidents.codeTitle': 'Announce a code',
  'incidents.codeHint': 'Staff on shift (or, when nobody marked a shift, every doctor, assistant and administrator) get an urgent Telegram and in-app alert at once.',
  'incidents.codeRed': 'Code red',
  'incidents.codeRedHint': 'Critical patient — all free hands needed',
  'incidents.codeYellow': 'Code yellow',
  'incidents.codeYellowHint': 'A free doctor is needed soon',
  'incidents.codeNote': 'Note',
  'incidents.codeRaise': 'Announce',
  'incidents.codeRaised': 'Code announced, colleagues alerted: {n}',
  'incidents.activeCodes': 'Active codes',
  'incidents.coming': 'Coming',
  'incidents.busy': 'Busy',
  'incidents.comingCount': 'Coming: {n}',
  'incidents.duty.on': 'On shift until {time}',
  'incidents.duty.off': 'I am on shift',
  'incidents.duty.title': 'My shift',
  'incidents.duty.hint': '«Code red» alerts go first to staff who marked a shift in their branch.',
  'incidents.duty.hours': 'Length, h',
  'incidents.duty.start': 'Start shift',
  'incidents.duty.end': 'End shift',
  'incidents.duty.now': 'On shift now',
  'incidents.duty.nobody': 'Nobody marked a shift yet.',
  'incidents.tab.register': 'Register',
  'incidents.tab.stats': 'Statistics',
  'incidents.tab.types': 'Types & SLA',
  'incidents.filter.status': 'Status',
  'incidents.filter.open': 'Open',
  'incidents.filter.all': 'All statuses',
  'incidents.filter.closed': 'Resolved and closed',
  'incidents.filter.category': 'Category',
  'incidents.filter.allCategories': 'All categories',
  'incidents.filter.type': 'Type',
  'incidents.filter.allTypes': 'All types',
  'incidents.filter.allBranches': 'All branches',
  'incidents.filter.overdue': 'Overdue only',
  'incidents.filter.mine': 'Mine',
  'incidents.search': 'Text, room or #',
  'incidents.col.number': '#',
  'incidents.col.type': 'Type',
  'incidents.col.title': 'What happened',
  'incidents.col.status': 'Status',
  'incidents.col.sla': 'Timer',
  'incidents.col.reported': 'Reported',
  'incidents.col.owner': 'Owner',
  'incidents.empty': 'No open incidents',
  'incidents.emptyHint': 'Noticed a breakdown, a complaint or a hazard? Press «Incident» — the owners are notified. In the Telegram bot use «📝 Інцидент».',
  'incidents.sla.ack': 'response',
  'incidents.sla.resolve': 'resolution',
  'incidents.sla.left': '{what} in {left}',
  'incidents.sla.late': '{what}: overdue by {left}',
  'incidents.overdue': 'Overdue',
  'incidents.legal': 'Legal escalation',
  'incidents.managersOnly': 'Managers only',
  'incidents.status.new': 'New',
  'incidents.status.acknowledged': 'Taken',
  'incidents.status.in_progress': 'In progress',
  'incidents.status.resolved': 'Resolved',
  'incidents.status.closed': 'Closed',
  'incidents.status.cancelled': 'Cancelled',
  'incidents.category.emergency': 'Emergency',
  'incidents.category.complaint': 'Complaints & conflicts',
  'incidents.category.technical': 'Technical',
  'incidents.category.clinical': 'Clinical',
  'incidents.category.safety': 'Occupational safety',
  'incidents.category.insurance': 'Insurance events',
  'incidents.category.memo': 'Staff memos',
  'incidents.category.other': 'Other',
  'incidents.channel.phone': 'Phone',
  'incidents.channel.instagram': 'Instagram',
  'incidents.channel.email': 'Email',
  'incidents.channel.in_person': 'In person',
  'incidents.channel.review': 'Review',
  'incidents.channel.telegram': 'Telegram',
  'incidents.channel.viber': 'Viber',
  'incidents.channel.other': 'Other',
  'incidents.severity.low': 'Low',
  'incidents.severity.normal': 'Normal',
  'incidents.severity.high': 'High',
  'incidents.severity.critical': 'Critical',
  'incidents.dur.min': '{n} min',
  'incidents.dur.hours': '{n} h',
  'incidents.dur.days': '{n} d',
  'incidents.detail': 'Incident',
  'incidents.number': '#{n}',
  'incidents.take': 'Take',
  'incidents.toWork': 'Start work',
  'incidents.resolve': 'Resolved',
  'incidents.close': 'Close',
  'incidents.cancel': 'Cancel incident',
  'incidents.reopen': 'Reopen',
  'incidents.resolveTitle': 'How was it resolved?',
  'incidents.closeTitle': 'Close incident',
  'incidents.cancelTitle': 'Cancel incident',
  'incidents.reopenTitle': 'Reopen',
  'incidents.resolution': 'Resolution',
  'incidents.resolutionHint': 'What was done; for complaints — the answer to the client',
  'incidents.reason': 'Reason',
  'incidents.comment': 'Comment',
  'incidents.confirm': 'Confirm',
  'incidents.field.ackDue': 'Respond by',
  'incidents.field.resolveDue': 'Resolve by',
  'incidents.field.acknowledged': 'Taken',
  'incidents.field.resolved': 'Resolved',
  'incidents.field.owner': 'Owner',
  'incidents.field.reporter': 'Reported by',
  'incidents.field.place': 'Where',
  'incidents.field.channel': 'Channel',
  'incidents.field.decision': 'Decision on the complaint',
  'incidents.field.asset': 'Equipment',
  'incidents.field.source': 'Source',
  'incidents.source.web': 'Web',
  'incidents.source.telegram': 'Telegram bot',
  'incidents.source.api': 'API / MCP',
  'incidents.byWhom': '{when} · {who}',
  'incidents.saveDecision': 'Save decision',
  'incidents.assign': 'Assign',
  'incidents.assignRole': 'Role',
  'incidents.assignUser': 'Person',
  'incidents.anyone': 'Anyone in the role',
  'incidents.noRole': 'Managers',
  'incidents.deadlines': 'Statutory deadlines',
  'incidents.deadlineMet': 'Done',
  'incidents.checklist': 'Checklist',
  'incidents.openChecklist': 'Open checklist',
  'incidents.checklistProgress': '{answered} of {total} done',
  'incidents.responses': 'Answers to the code',
  'incidents.noResponses': 'Nobody answered yet',
  'incidents.photosTitle': 'Photos ({n})',
  'incidents.timeline': 'Timeline',
  'incidents.commentPlaceholder': 'What was done, what is still needed…',
  'incidents.attach': 'Add photos',
  'incidents.sendComment': 'Send',
  'incidents.event.created': 'Reported',
  'incidents.event.comment': 'Comment',
  'incidents.event.status': 'Status: {from} → {to}',
  'incidents.event.assign': 'Owner changed',
  'incidents.event.update': 'Details changed',
  'incidents.event.escalation.ack': 'Escalated: no response in time',
  'incidents.event.escalation.resolve': 'Escalated: not resolved in time',
  'incidents.event.alert': 'Colleagues alerted: {n}',
  'incidents.event.response.coming': 'Coming',
  'incidents.event.response.busy': 'Busy',
  'incidents.event.photo': 'Photo added',
  'incidents.event.deadline': 'Deadline missed: {label}',
  'incidents.system': 'System',
  'incidents.stats.total': 'Incidents',
  'incidents.stats.open': 'Open',
  'incidents.stats.overdue': 'Overdue',
  'incidents.stats.ackRate': 'Responded in time',
  'incidents.stats.resolveRate': 'Resolved in time',
  'incidents.stats.avgAck': 'Average response',
  'incidents.stats.avgResolve': 'Average resolution',
  'incidents.stats.count': 'Count',
  'incidents.stats.byMonth': 'By month',
  'incidents.stats.month': 'Month',
  'incidents.stats.empty': 'No incidents in this period',
  'incidents.stats.period': 'Period',
  'incidents.stats.days': 'Last {n} days',
  'incidents.types.owner': 'Owner',
  'incidents.types.escalate': 'Escalation',
  'incidents.types.ack': 'Response',
  'incidents.types.resolve': 'Resolution',
  'incidents.types.deadlines': 'Deadlines',
  'incidents.types.edit': 'Edit “{title}”',
  'incidents.types.editTitle': 'Incident type',
  'incidents.types.ackMin': 'Response, min',
  'incidents.types.resolveMin': 'Resolution, min',
  'incidents.types.active': 'Active',
  'incidents.types.confirmed': 'Values confirmed by the owner',
  'incidents.types.seed': 'Add standard types',
  'incidents.types.saved': 'Saved',
  'incidents.types.inactive': 'Archived',
  'today.openIncidents': 'Open incidents',
  'today.noIncidents': 'No open incidents',
}
